import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import NotificationSettingResource from '@ane/exp-data/lib/resources/NotificationSettingResource';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const actionPrefix = 'DeleteNotificationSetting';
const deleteNotificationSettingDetailEpicReducerArg = {
    actionPrefix: actionPrefix,
    reduxKeyNested: () => ['value'],
    loadResource: (request) => NotificationSettingResource.deleteNotificationSetting(request.workspaceId, request.adminSubscriptionName),
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const deleteNotificationSettingEpicReducer = loadResourcesUtils(deleteNotificationSettingDetailEpicReducerArg);
export const deleteNotificationSettingStateDefault = {
    value: getDefaultAsyncWrapperObj(),
};
// Reducer
export const DeleteNotificationSettingReducer = (state = deleteNotificationSettingStateDefault, action) => {
    state = deleteNotificationSettingEpicReducer.reduxChange(state, action);
    return state;
};
export default DeleteNotificationSettingReducer;

//# sourceMappingURL=DeleteNotificationSetting.ducks.js.map
